/**
 * Moderation Cases Tab
 *
 * Displays active moderation cases for a specific topic with multi-select support
 */

import { Heading, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationCasesTab.css';

interface ModerationTopic {
  id: string;
  name: string;
}

interface ModerationCasesTabProps {
  communityId: string;
  topicId: string;
  topic: ModerationTopic;
}

export function ModerationCasesTab({ communityId: _communityId, topicId: _topicId, topic }: ModerationCasesTabProps) {
  // Component disabled - no API integration yet
  return (
    <div className={styles.emptyCasesState}>
      <div>
        <Heading level="h3">Cases for {topic.name}</Heading>
        <Text className={styles.emptyCasesText}>No API Integration</Text>
        <Text className={styles.emptyCasesText}>Case listing and management will be available once the moderation cases API is integrated.</Text>
      </div>
    </div>
  );
}
